import { FC, ReactNode } from "react";
import { TbHelpCircleFilled } from "react-icons/tb";
import { LogoIcon } from "../../../assets/svg";

interface Prop {
  children: ReactNode;
}

export const EnterpriseAuthContainer: FC<Prop> = ({ children }) => {
  return (
    <div className="w-full h-screen overflow-y-auto md:w-1/2 flex flex-col justify-between bg-white p-4 md:p-5 lg:p-8">
      <div>
        <div>
          <img src={LogoIcon} alt="Company Logo" className="w-20 h-8" />
        </div>
        <div className="w-full lg:w-[437px] mt-4 md:mt-8 lg:mt-10 flex flex-col mx-auto gap-4">
          {children}
        </div>
      </div>
      <footer className="flex items-center gap-1 text-base font-medium font-satoshi text-center lg:text-left text-bash mt-4 pt-4">
        <TbHelpCircleFilled />
        <p>
          Got any questions?{" "}
          <a
            href="https://www.buildwithbnkle.com/contact"
            target="blank"
            className="text-bblue hover:underline"
          >
            Contact Us
          </a>
        </p>
      </footer>
    </div>
  );
};
